module.exports = __webpack_public_path__ + "img/login_bg.303cfb6e.png";